export default __webpack_public_path__ + "static/Retul_Promo_Video_Comfort_Web-6980b4df2cd72659d62f23adfb1f7bbc.jpg";